module.exports = __webpack_public_path__ + "static/img/Angus_Brayshaw_mobile.8df8ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Angus_Brayshaw_mobile.jpg
// module id = H7EQ
// module chunks = 0